import React, { Component } from 'react'

export default class TitleH4 extends Component {
  render() {
    return (
      <div>
        <h4 className="title">{this.props.title}</h4>
        <p className="subtitle">
         {this.props.subtitle}
											</p>
      </div>
    )
  }
}
